import CallToAction from "components/CallToAction"

export default function DefaultSidebarFormContent() {
  return (
    <div>
      <h2 className="text-white pb-4 text-m3 lg:text-l1">Get Help Now</h2>
      <p className="text-white">
        During a free consultation, we will look at the important aspects of your case, answer your questions, and
        explain your legal rights and options clearly. All submissions are confidentially reviewed by Mark Breyer.
      </p>
      <CallToAction href="tel:6024576222" style="primary-ghost">
        (602) 457-6222
      </CallToAction>
    </div>
  )
}
